var _path;
/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';
class IconPostToSisLine extends Component {
  constructor(...args) {
    super(...args);
    this.ref = null;
    this.handleRef = el => {
      const elementRef = this.props.elementRef;
      this.ref = el;
      if (typeof elementRef === 'function') {
        elementRef(el);
      }
    };
  }
  render() {
    return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
      name: "IconPostToSis",
      viewBox: "0 0 1920 1920",
      elementRef: this.handleRef
    }), _path || (_path = /*#__PURE__*/React.createElement("path", {
      d: "M922.315 1188.96c20.8-20.8 54.613-20.8 75.413 0l266.667 266.667-75.414 75.413-175.68-175.573v564.586h-106.56v-564.586l-175.68 175.573-75.413-75.413ZM508.928 220.405c88.533-23.36 205.013 12.694 275.84 85.654l-76.373 74.346c-43.734-44.906-120.96-70.4-172.48-56.746-25.387 6.613-40.32 21.333-46.827 45.973-17.28 65.493 113.92 112.853 115.307 113.387 86.08 28.16 221.653 111.253 182.4 243.306-18.454 62.08-63.68 104.96-127.36 120.534-17.707 4.373-36.374 6.506-55.36 6.506-76.587 0-159.254-34.24-215.68-92.266l76.373-74.347c43.2 44.48 117.653 69.547 169.067 56.533 26.986-6.613 43.093-21.653 50.666-47.253 19.414-64.96-112.213-111.253-113.493-111.787-85.227-28.16-219.733-110.72-185.067-241.813 16.32-62.187 60.16-105.493 122.987-122.027Zm746.613 0c88.534-23.36 205.014 12.694 275.84 85.654l-76.373 74.346c-43.733-44.906-120.96-70.4-172.48-56.746-25.387 6.613-40.32 21.333-46.827 45.973-17.28 65.493 113.92 112.853 115.307 113.387 86.08 28.16 221.653 111.253 182.4 243.306-18.453 62.08-63.68 104.96-127.36 120.534-17.707 4.373-36.373 6.506-55.36 6.506-76.587 0-159.253-34.24-215.68-92.266l76.373-74.347c43.2 44.48 117.654 69.547 169.067 56.533 26.987-6.613 43.093-21.653 50.667-47.253 19.413-64.96-112.214-111.253-113.494-111.787-85.226-28.16-219.733-110.72-185.066-241.813 16.32-62.187 60.16-105.493 122.986-122.027Zm-242.208-7.072v640H906.667v-640h106.666Zm639.968 693.334c0 29.333-24 53.333-53.333 53.333h-1280c-29.333 0-53.333-24-53.333-53.333V160c0-29.333 24-53.333 53.333-53.333h1280c29.333 0 53.333 24 53.333 53.333v746.667ZM1599.968 0h-1280c-88.213 0-160 71.787-160 160v746.667c0 88.213 71.787 160 160 160h1280c88.213 0 160-71.787 160-160V160c0-88.213-71.787-160-160-160Z",
      fillRule: "evenodd"
    })));
  }
}
IconPostToSisLine.glyphName = 'post-to-sis';
IconPostToSisLine.variant = 'Line';
IconPostToSisLine.displayName = 'IconPostToSisLine';
// eslint-disable-next-line react/forbid-foreign-prop-types
IconPostToSisLine.propTypes = {
  ...SVGIcon.propTypes
};
IconPostToSisLine.allowedProps = [...SVGIcon.allowedProps];
export default IconPostToSisLine;
export { IconPostToSisLine };